/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeInvoiceDto, serializeRefundPaymentRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type RefundPaymentRequest } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/payments/{paymentId}/refund
 */
export interface RefundRequestBuilder extends BaseRequestBuilder<RefundRequestBuilder> {
    /**
     * Books a refund against a settled payment. This records the money as returned; it does not instruct a card processor or bank to move it, so issue the refund with the provider separately. Only a completed or partly refunded payment can be refunded — pending, failed and fully refunded ones are not — the amount must be greater than zero, and the refunds on a payment may never total more than the payment itself. Refunds accumulate, so a payment can be returned in instalments; the payment reads PartiallyRefunded until the last one, then Refunded. The invoice follows the money back: a Paid invoice reopens as PartiallyPaid, and refunding everything returns it to Issued. A voided or cancelled invoice keeps its terminal status. Once nothing is left paid, the invoice can be voided or its discount changed again.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: RefundPaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Books a refund against a settled payment. This records the money as returned; it does not instruct a card processor or bank to move it, so issue the refund with the provider separately. Only a completed or partly refunded payment can be refunded — pending, failed and fully refunded ones are not — the amount must be greater than zero, and the refunds on a payment may never total more than the payment itself. Refunds accumulate, so a payment can be returned in instalments; the payment reads PartiallyRefunded until the last one, then Refunded. The invoice follows the money back: a Paid invoice reopens as PartiallyPaid, and refunding everything returns it to Issued. A voided or cancelled invoice keeps its terminal status. Once nothing is left paid, the invoice can be voided or its discount changed again.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RefundPaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RefundRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/payments/{paymentId}/refund";
/**
 * Metadata for all the requests in the request builder.
 */
export const RefundRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RefundRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRefundPaymentRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
